import React, { useEffect } from 'react';
import ManageUserTable from '../../../components/ManageUser/ManageUserTable';
import { useUserContext } from '../../../contexts/UserContext';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import { useNavigate } from 'react-router-dom';

const ManageUsers = () => {
  const navigate = useNavigate();
  const { userData } = useUserContext();
  const { content } = useContentfulContext();

  useEffect(() => {
    if (userData?.selectedOrganization?.role?.[0]?.name?.toLowerCase() !== 'owner') {
      navigate(`/dashboard`);
    }
  }, [userData?.selectedOrganization, navigate]);

  return (
    <main id="main" className="stride-page-shell flex flex-col space-y-6">
      <div>
        <span className="stride-eyebrow">Settings / Team</span>
        <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
          {content?.MANAGE_USERS?.title}
        </h1>
        <p className="text-sm text-stride-muted mt-1">
          {content?.MANAGE_USERS?.description}
        </p>
      </div>
      <div className="w-full">
        <ManageUserTable />
      </div>
    </main>
  );
};

export default ManageUsers;
